import React, { useEffect, useRef, useState } from 'react';
import getDomain from './domain';
import { Avatar, Box, Modal, Stack } from '@mui/material';
import { Movie } from '@mui/icons-material';

const Player = ({ magnet }) => {
  const [open, setOpen] = useState(false);
  const [streamUrl, setStreamUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const videoRef = useRef(null);

  console.log('Selected Magnet:', magnet);

  // Trigger modal open and stream fetch when a new magnet is passed
  useEffect(() => {
    if (magnet) {
      setOpen(true);
      handleStream();
    }
  }, [magnet]);

  const handleStream = async () => {
    if (!magnet) {
      setError('Please provide a magnet link.');
      return;
    }

    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${getDomain()}/stream?magnet=${encodeURIComponent(magnet)}`);
      if (!response.ok) {
        throw new Error('Failed to start stream');
      }
      const { streamUrl } = await response.json();
      setStreamUrl(streamUrl);

      // Trigger video element reload
      if (videoRef.current) {
        videoRef.current.load();
      }
    } catch (err) {
      console.error('Error fetching stream:', err);
      setError('Error starting the stream. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack spacing={2} sx={{ padding: '20px' }}>
      <Avatar
        sx={{
          position: 'fixed',
          width: '50px',
          height: '50px',
          left: '20px',
          bottom: '20px',
          cursor: 'pointer',
        }}
        onClick={() => setOpen(true)}
      >
        <Movie />
      </Avatar>

      <Modal
        open={open}
        onClose={() => setOpen(false)} // Close the modal when clicking outside
        aria-labelledby="video-modal-title"
        aria-describedby="video-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 2,
            outline: 'none',
            borderRadius: '8px',
            width: 'auto',
            height: 'auto',
          }}
        >
          {loading ? (
            <p>Loading stream...</p>
          ) : error ? (
            <p style={{ color: 'red' }}>{error}</p>
          ) : (
            <video
              ref={videoRef}
              controls
              autoPlay
              style={{ width: '100%', maxWidth: '800px' }}
            >
              <source src={streamUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </Box>
      </Modal>
    </Stack>
  );
};

export default Player;